// extracted by mini-css-extract-plugin
export var infoItem = "_nz-2";
export var title = "_nz-0";
export var value = "_nz-1";